module.exports = __webpack_public_path__ + "img/Frame 67906.f0e81ca0.png";